<template>
  <div class="w-full max-w-xxs flex flex-col items-center mx-auto my-5">
    <a
      @click.prevent="setTeamMemberModal"
      class="w-48 h-48 rounded-full bg-yellow-brand flex items-center justify-center mb-2.5"
      href="#"
    >
      <img
        v-if="teamMember.image"
        :src="teamMember.image.urls.square_180"
        :alt="teamMember.image.alt_text"
        class="w-45 h-45 rounded-full"
      />
    </a>
    <p class="text-center font-primary font-extrabold text-20 leading-1.2 mb-2.5">
      {{ teamMember.name }}
    </p>
    <p class="text-center font-primary font-extrabold text-12 text-blue-brand leading-1.17">
      {{ teamMember.role }}
    </p>
    <p class="text-center font-primary font-extrabold text-12 text-blue-brand leading-1.17 mb-2.55">
      {{ teamMember.location }}
    </p>
    <button class="button min-w-0 w-full" type="button" @click.prevent="setTeamMemberModal">
      View bio
    </button>
  </div>
</template>

<script>
export default {
  props: {
    teamMember: {
      type: Object,
      required: true,
    },
  },

  methods: {
    setTeamMemberModal() {
      this.$store.commit('modals/SET_TEAM_MEMBER_MODAL', this.teamMember.id);
    },
  },
};
</script>
